<script>
  import { checkLanguage, doVoice } from "./functions.js";
  import { createEventDispatcher } from "svelte";
  const dispatch = createEventDispatcher();

  import { questionsWrite, settings, statistics } from "./store.js";

  let questions = [
    {
      id: 1,
      key: "Ask question once.  Total Quiz Questions: " + $questionsWrite.length
    },
    {
      id: 2,
      key:
        "Ask question twice. Total Quiz Questions: " +
        $questionsWrite.length * 2
    },
    {
      id: 3,
      key:
        "Ask question 3 times. Total Quiz Questions: " +
        $questionsWrite.length * 3
    }
  ];

  let answers = [{ id: 2, key: "Give 2 choices for answer" }];
  let i;
  for (i = 3; i <= $settings.answerChoicesMax; i++) {
    answers.push({ id: i, key: "Give " + i + " choices for answer" });
  }

  // function doVoice2(val, lang) {
  //   var synth = window.speechSynthesis;
  //   var utterThis = new SpeechSynthesisUtterance(val);
  //   utterThis.lang = lang;
  //   utterThis.rate = 0.8;
  //   synth.speak(utterThis);
  // }

  var checkVoices = setInterval(function() {
    if (typeof speechSynthesis === "undefined") {
      clearInterval(checkVoices);
    }
    var voices = speechSynthesis.getVoices();
    // console.log(voices);
    if (voices.length !== 0) {
      $settings.rVoice = checkLanguage($settings.rCode);
      if (!$settings.rVoice) {
        $settings.rCode = $settings.rCode.replace("-", "_");
        $settings.rVoice = checkLanguage($settings.rCode);
      }
      $settings.eVoice = checkLanguage($settings.eCode);
      if (!$settings.eVoice) {
        $settings.eCode = $settings.eCode.replace("-", "_");
        $settings.eVoice = checkLanguage($settings.eCode);
      }
      clearInterval(checkVoices);
    }
  }, 1000);
  checkVoices;
</script>

<div style="text-align:center; ">
  <a class="button is-rounded is-outlined is-pulled-left" href="/">
    <span class="icon is-medium">
      <i class="fas fa-arrow-circle-left" />
    </span>
    <span>Quizzes</span>
  </a>
  <button
    class="button is-rounded is-outlined is-medium"
    on:click={() => {
      dispatch('quizStart');
    }}>
    Begin Quiz
  </button>

</div>

<div
  class="table-container"
  style="border: thin dashed lightgrey; padding:5px; margin-top:15px;">
  <table
    class="table is-fullwidth is-striped"
    style2="background-color:#E0F8F1">
    <thead>
      <tr>
        <td colspan="3">
          <div class="select is-small">
            <select bind:value={$settings.requiredAnswersPerQuestion}>
              {#each questions as question}
                <option value={question.id}>{question.key}</option>
              {/each}
            </select>
          </div>
        </td>
      </tr>
      <tr>
        <td colspan="3">
          <label class="is-small">
            <input
              class="is-small"
              type="checkbox"
              bind:checked={$settings.rotate}
              on:change={() => {
                dispatch('quizRotate');
              }} />
            Rotate
          </label>
          <label class="is-small is-pulled-right">
            <input
              class="is-small"
              type="checkbox"
              bind:checked={$settings.references} />
            Show References
          </label>
        </td>
      </tr>

      <tr style="background-color:lightgrey">
        <th>
          <abbr title="Position">#</abbr>
        </th>
        <th>
          <abbr title="Term">Questions</abbr>
        </th>
        <th>
          <abbr title="Description">Answers</abbr>
        </th>
      </tr>
    </thead>
    <tbody>

      {#each $questionsWrite as item, i}
        <tr>
          <td>{i + 1}</td>
          <td>{item.key}</td>
          <td>{item.val}</td>
        </tr>
        <!-- {#if $settings.references} -->
        <tr hidden={!$settings.references}>
          <td colspan="3">
            {#if $settings.rVoice}
              <button
                class="button"
                aria-label="close"
                on:click={() => {
                  doVoice(item.rKey, $settings.rCode);
                }}>
                <i class="fas fa-play-circle" />
              </button>
            {:else if i == 0}
              <p class="has-text-danger">
                Your browser does not support text to speech for Russian so no
                audio is displayed for Russian words. Use latest version of
                Google Chrome to enable Russian audio.
              </p>
            {/if}
            <a
              class="button"
              href="https://translate.google.com/#ru|en|{item.rKey}"
              target="_blank">
              <i class="fas fa-external-link-alt" />
              G
            </a>
            <a
              class="button"
              href="https://dictionary.reverso.net/russian-english/{item.rKey}"
              target="_blank">
              <i class="fas fa-external-link-alt" />
              R
            </a>
            <a
              class="button"
              href="https://en.wiktionary.org/wiki/{item.rKey}"
              target="_blank">
              <i class="fas fa-external-link-alt" />
              V
            </a>
            <a
              class="button"
              href="https://www.multitran.com/m.exe?l1=1&l2=2&s={item.rKey}"
              target="_blank">
              <i class="fas fa-external-link-alt" />
              M
            </a>
            {#if $settings.eVoice}
              <button
                class="button"
                aria-label="close"
                on:click={() => {
                  doVoice(item.eVal, $settings.eCode);
                }}>
                <i class="fas fa-play-circle" />
              </button>
            {/if}
          </td>
        </tr>
        <!-- {/if} -->
      {/each}

    </tbody>
  </table>
</div>
<div style="text-align:center; ">
  <a class="button is-rounded is-outlined is-pulled-left" href="/">
    <span class="icon is-medium">
      <i class="fas fa-arrow-circle-left" />
    </span>
    <span>Quizzes</span>
  </a>
  <button
    class="button is-rounded is-outlined is-medium"
    on:click={() => {
      dispatch('quizStart');
    }}>
    Begin Quiz
  </button>
</div>
